declare var appConfig: any;

export class StaticReferences {
  private apiServer: string;
  private apiVersion: string;
  private apiDuoServer: string;
  private apiDuoVersion: string;
  private action: any;
  private defaultSort: any;
  private supplierFilter: number[];
  private ssoLogout: string;
  private urlSlPlusSupport: string;
  private urlRecruitment: string;
  private slplusdomain: string;
  private duoDomain: string;
  private environment: string;

  //  #region Constructor
  constructor() {
    this.apiServer = appConfig.apiServer;
    this.apiVersion = appConfig.apiVersion;
    this.apiDuoServer = appConfig.apiDuoServer;
    this.apiDuoVersion = appConfig.apiDuoVersion;
    this.ssoLogout = appConfig.ssoLogout;
    this.urlSlPlusSupport = appConfig.contactForm;
    this.urlRecruitment = 'https://pro.groupeseloger.com';
    this.action = {
      'GET_CONTACTS_INFO': 'Contacts',
      'GET_PANIER': 'Reglement',
      'PUT_AJOUT_PANIER': 'Reglement/AjoutPanier',
      'PUT_CANCEL_PAYEMENT': 'Reglement/CancelPayment',
      'PUT_PAY': 'Reglement/Pay',
      'PUT_CLEAR_PAYEMENT': 'Reglement/ClearPayment',
      'DELETE_LIGNE_PANIER': 'Reglement',
      'PUT_ENVOYER_MAIL': 'Contacts/EnvoiMail',
      'GET_FOURNISSEURS': 'Fournisseurs',
      'CHECK_BILLINGFILE_EXISTS': 'PieceComptable/CheckIfBillingFileExists',
      'GET_ACCOUNT_LIST': 'PieceComptable/GetForFilters',
      'GET_SOLDE_PAY_LIST': 'SoldeAPayer/GetForFilters',
      'GET_BON_CMD_LIST': 'BonCommande/GetForFilters',
      'GET_EXTRAIT_LIST': 'ExtraitCompte/GetForFilters',
      'GET_EXTRAIT_LIST_CSV': 'ExtraitCompte/GetForCSV',
      'GET_CARD_LIST': 'PaymentMethod/ListeCards',
      'GET_CARD': 'PaymentMethod/Card',
      'PUT_CARD_DEFAULT': 'PaymentMethod/ChangeCardDefault',
      'DELETE_CARD': 'PaymentMethod/DeleteCard',
      'GET_DOCUMENT_RIB': 'PaymentMethod/GetPdfRib',
      'GET_ADDRESSES': 'AutoComplete/Find',
      'GET_URL_IFRAME_SIGN': 'BonCommande/{0}/SignatureUrl/{1}',
      'POST_CONTACT_SIGN': 'BonCommande/UpdateContact',
      'GET_SEPAMANDATE_LIST': 'PaymentMethod/ListSepaMandate',
      'GET_MANDAT_SEPA_LINK': 'BonCommande/{0}/SignatureUrl/{1}/Sepa',
      'POST_SEPA_GENERATE': 'Sepa/PrepareToSign/{0}/{1}/{2}',
      'GET_SEPA_STATUS': 'SepaStatus/{0}/{1}/{2}',
      'GET_SEPA_STATUS_CONNECT': 'SepaStatus/{0}/{1}',
      'GET_ACCESS_SEPA': 'Sepa/AccessSepa/{0}',
      'GET_LIST_SEPA_MANDATE': 'Sepa/ListSepaMandate',
      'GET_EXCHANGE_TOKENS': 'Authentication/ExchangeTokens',
      'GET_USER_INFO': 'Authentication/User',
      'GET_NAVIGATION': 'Navigation',
      'POST_DIRECT_DEBIT_ORDER': 'DirectDebit/Order/{0}',
      'GET_UNSIGNED_BDC': 'BonCommande/GetUnsignedDocument/{0}/{1}',
      'POST_SEPA_INFOS': 'BonCommande/AddSepa/{0}/{1}',
      'POST_ERROR_BDC': 'BonCommande/{0}/PathError/{1}',
      'GET_NB_LATE_BILLS': 'PieceComptable/GetOutdatedUnpaidInvoiceNumber'
    };
    this.defaultSort = {
      'PANIER_DEFAUT_SORT': 'BillingDate'
    };
    this.supplierFilter = [3, 7];
    this.slplusdomain = appConfig.slplusdomain;
    this.duoDomain = appConfig.duoDomain;
    this.environment = appConfig.environment;
  }
  //  #endregion Constructor

  public get ApiServer(): string { return this.apiServer; }
  public get ApiVersion(): string { return this.apiVersion; }
  public get ApiDuoServer(): string { return this.apiDuoServer; }
  public get ApiDuoVersion(): string { return this.apiDuoVersion; }
  public get Action(): any { return this.action; }
  public get DefaultSort(): any { return this.defaultSort; }
  public get SupplierFilter(): number[] { return this.supplierFilter; }
  public get SsoLogout(): string { return this.ssoLogout; }
  public get UrlSlPlusSupport(): string { return this.urlSlPlusSupport; }
  public get UrlRecruitment(): string { return this.urlRecruitment; }
  public get Slplusdomain(): string { return this.slplusdomain; }
  public get DuoDomain(): string { return this.duoDomain; }
  public get Environment(): string { return this.environment; }
}
